import React from "react";

import type { RebookSummaryHeaderProps } from "./types";

export const useRebookSummaryHeader = ({ data }: RebookSummaryHeaderProps) => {
  const lastSegment = React.useMemo(
    () => data.slices[0].segments[data.slices[0].segments.length - 1],
    [data]
  );

  const airports = React.useMemo(
    () => data.tripContext?.airports ?? {},
    [data.tripContext?.airports]
  );

  const destinationCode = React.useMemo(
    () => lastSegment.destination.locationCode,
    [lastSegment.destination.locationCode]
  );

  const destinationName = React.useMemo(
    () => airports[destinationCode]?.cityName ?? destinationCode,
    [airports, destinationCode]
  );

  return React.useMemo(
    () => ({
      text: {
        destinationName,
        destinationCode,
      },
    }),
    [destinationCode, destinationName]
  );
};
